import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";
import { SxProps, Theme, ThemeProvider } from "@mui/material";
import theme from "src/styles/mainstyle";
import { useMediaQuery, useTheme } from "@mui/material";

interface ContentBoxWithTitleProps {
  children: ReactNode;
  id?: string;
  title?: string;
  sx?: SxProps<Theme>;
}

export default function ContentBox({
  children,
  id,
  title,
  sx,
}: ContentBoxWithTitleProps) {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // pb: 2, // Add padding to the bottom
          // pt: 2, // Add padding to the top
        }}
        id={id}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            // pb: 2, // Add padding to the bottom
            // pt: 8, // Add padding to the top
          }}
        >
          <Box
            sx={{
              padding: 5, // Add padding to the entire box
              backgroundColor: "white", // Set the background color to white
            }}
          >
            <Typography
              variant="h2"
              sx={{
                textAlign: "left",
                pb: 5,
              }}
            >
              {title}
            </Typography>
            <InnerContentBox sx={sx} children={children} />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export function InnerContentBox({ children, sx }: ContentBoxWithTitleProps) {
  const mobileTheme = useTheme();
  const isDesktop = useMediaQuery(mobileTheme.breakpoints.down("sm"));
  return (
    <Box
      className="inner-content-box" // add this
      sx={{
        display: "flex",
        justifyContent: "center", // Center horizontally
        flexDirection: "column",
        alignItems: "start", // Top vertically
        margin: "auto", // Center the box
        maxWidth: "100%", // Limit the width to 80% of the parent
        overflowX: "hidden",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        backgroundColor: theme.palette.primary.main,
        height: "100%", // Set the height to 100% of the parent
        // padding: !isDesktop ? 10 : 2, // Add padding to the entire box
        padding: { xs: 2, sm: 3, md: 5 },
        borderRadius: !isDesktop ? "25px" : "15px", // rounded corners
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
